module.exports = __webpack_public_path__ + "static/media/3655E8_1_0.c7c1f4b9.ttf";